import { prefersReducedMotion } from '@theme/utilities';

/**
 * Tiroir panier : « Total + Valider ma commande » est collé en bas et le code de réduction défile juste
 * au-dessus (voir snippets/cart-summary.liquid et snippets/cart-drawer.liquid). Sur un petit écran,
 * l'accordéon ouvert (champ, bouton « Appliquer », message d'erreur) pourrait se retrouver caché derrière
 * ce bloc collé : on fait donc défiler la zone pour le garder visible.
 * (`scroll-padding-block-end` de .cart-drawer__content réserve la place du bloc collé.)
 */

const DISCOUNT_SCOPE = '#cart-drawer .cart-drawer__discount';

/** @param {Element} element */
function reveal(element) {
  const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

  requestAnimationFrame(() => element.scrollIntoView({ block: 'nearest', behavior }));
  // la hauteur de l'accordéon s'anime : on recale une fois l'animation terminée
  setTimeout(() => element.scrollIntoView({ block: 'nearest', behavior }), 260);
}

// Ouverture de l'accordéon « Code de réduction » (l'événement `toggle` ne remonte pas : on l'écoute en capture)
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;

    if (details instanceof HTMLDetailsElement && details.open && details.closest(DISCOUNT_SCOPE)) {
      reveal(details);
    }
  },
  true
);

// Message d'erreur d'un code refusé : cart-discount.js retire la classe « hidden » de .cart-discount__error
const drawer = document.querySelector('theme-drawer#cart-drawer');

if (drawer) {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const target = mutation.target;

      if (target instanceof HTMLElement && target.matches('.cart-discount__error') && !target.classList.contains('hidden')) {
        reveal(target);
        break;
      }
    }
  }).observe(drawer, { subtree: true, attributes: true, attributeFilter: ['class'] });
}
